import React from 'react';
import character from '../../images/character.svg';
import iconTask from '../../images/icon-task.svg';
import iconTBM from '../../images/icon-tbm.svg';
import { IoIosArrowForward } from 'react-icons/io';
import { useNavigate } from "react-router-dom";

export default function CardService({ sttstcInfo }: any) {
  const navigate = useNavigate();
  const totWorkHandler = () => { navigate('/total-work') };
  const smartTBMHandler = () => {
    navigate('/tbm-current-status')
  };
  const nonconformityHandler = () => {

    navigate('/nonconformity');
  };
  const suggestHandler = () => {
    navigate('/sgst')
  };
  const stopHandler = () => { navigate('/stop-request', { state: { isRequest: false } }); };

  return (
    <div className='bg-white w-full rounded-[8px] md:rounded-[20px] flex flex-col items-center mt-[0.563rem] md:mt-[1.47rem] relative'>
      <img className='absolute w-[3.7rem] top-[-19%] right-[2%] md:w-[9.25rem]' src={character} alt='character' />
      <p className='text-txtBlack font-semibold text-[1rem] mt-[1.06rem] md:text-40 md:mt-[2.65rem] w-[84.7%]'>오늘의 현황</p>
      <table className='table-fixed text-txtBlack mt-[0.638rem] ml-[1.875rem] mr-[0.75rem] md:mt-[1.595rem] md:ml-[4.67rem] md:mr-[1.875rem] w-[90%] z-10'>
        <tbody>
          <tr onClick={totWorkHandler} className='hover:cursor-pointer'>
            <td className='w-[12%] text-[0.75rem] sm:text-[0.875rem] md:text-[2rem] border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.625rem] md:pb-[1.562rem]'><img src={iconTask} alt='task' className='md:w-[77px]' /></td>
            <td className='w-[39%] text-[0.75rem] sm:text-[0.875rem] md:text-[2rem] border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.625rem] md:pb-[1.562rem]'>일반작업/위험작업</td>
            <td className='w-[40%] text-[0.85rem] sm:text-[0.938rem] md:text-[2.3rem] text-right text-point font-preBold border-[0.5px] border-x-0 border-t-0 border-[#C5C5C5] border-opacity-[50%] pb-[0.625rem] md:pb-[1.562rem]'>{sttstcInfo.totWrkInfo?.totWrkCnt - sttstcInfo.totWrkInfo?.dngrWrkCnt}/{sttstcInfo.totWrkInfo?.dngrWrkCnt}<span className='text-txtBlack'>건</span></td>
            <td className='text-[0.813rem] md:text-[2.032rem] pb-[0.625rem] md:pb-[1.562rem]'><IoIosArrowForward /></td>
          </tr>
          <tr onClick={smartTBMHandler} className='hover:cursor-pointer'>
            <td className='pt-[0.625rem] md:pt-[1.562rem]'><img src={iconTBM} alt='tbm' className='md:w-[77px]' /></td>
            <td className='text-[0.75rem] sm:text-[0.875rem] md:text-[2.187rem] pt-[0.625rem] md:pt-[1.562rem]' >개인 TBM</td>
            <td className='text-[0.85rem] sm:text-[0.938rem] md:text-[2.187rem] text-right text-point font-preBold pt-[0.625rem]'>{sttstcInfo.smrtTbmStatInfo?.wrkrCmpltCnt}/{sttstcInfo.smrtTbmStatInfo?.wrkrTotCnt}({sttstcInfo.smrtTbmStatInfo?.wrkrTbmRate}%)</td>
            <td className='text-[0.813rem] md:text-[2.032rem] pt-[0.625rem] md:pt-[1.562rem]'><IoIosArrowForward /></td>
          </tr>
        </tbody>
      </table>
      <div className='w-[90%] h-[4.5rem] sm:h-[5.4rem] md:h-[13.5rem] bg-[#FFEEEF] bg-opacity-[54%] rounded-[8px] md:rounded-[20px] my-[0.625rem] md:my-[1.562rem] flex flex-col justify-center relative pr-[0.4rem]'>
        <div className='absolute w-0 h-28 md:h-[70px] border-[0.5px] border-l-0 border-[#C5C5C5] border-opacity-[50%] left-[33%]' />
        <div className='absolute w-0 h-28 md:h-[70px] border-[0.5px] border-l-0 border-[#C5C5C5] border-opacity-[50%] right-[36%]' />
        <table className='text-mainTxtPoint text-[1.56rem] md:text-[3.9rem] font-preBold w-full table-fixed text-center'>
          <tbody>
            <tr className='hover:cursor-pointer'>
              <td onClick={nonconformityHandler}>{sttstcInfo.sftyChkDataCnt}</td>
              <td onClick={suggestHandler}>{sttstcInfo.sgstDataCnt}</td>
              <td onClick={stopHandler}>{sttstcInfo.wrkStopDataCnt}</td>
            </tr>
            <tr className='hover:cursor-pointer text-[0.8rem] sm:text-[0.875rem] md:text-[2.187rem] text-txtBlack'>
              <td onClick={nonconformityHandler}>부적합</td>
              <td onClick={suggestHandler}>건의사항</td>
              <td onClick={stopHandler}>작업중지요청</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

